import React, { useEffect, useState } from "react";
import { no_giftcard } from "../../../Image/Index";
import { Link } from "react-router-dom";
import { giftCard, CountryRegions, giftCardUpdate } from "../../../actions/auth";
import { ValidatorForm } from "react-form-validator-core";
import Header from "../../layout/Header";
import CardViewModal from "./CardViewModal";
import swal from "sweetalert";
import TextValidator from "../../partial/TextValidator";
import Card from "./Card";

const GiftCardVoucher1 = () => {
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [isSelected, setIsSelected] = useState([]);

    const [formData, setFormData] = useState({
        cardsForUpdate: [],
        getCards: [],
    });
    const [country, setCountry] = useState();

    const [state, setState] = useState({
        selectedCountry: "",
        options: [],
    });
    const { selectedCountry, options } = state;
    const { cardsForUpdate, getCards } = formData;

    const [selectCountry, setSelectCountry] = useState({
        getSearchedCountry: [],
        allSelectCountry: "",
        countryToggle: false,
        searchCountryTerm: "",
    });

    const [card, setCard] = useState({
        getSearchedCard: [],
        cardFlag: false,
        allSelectCard: "",
        recommended: [],
        fashionAndLifestyle: [],
        electronics: [],
        homeAndLiving: [],
        goldAndJewelry: [],
        travelAndEntertainment: [],
        foodAndRestaurant: [],
    });

    const [isDivVisible, setIsDivVisible] = useState(false);
    const toggleDivVisibility = () => {
        setIsDivVisible(!isDivVisible);
    };

    const [cardResponse, setCardResponse] = useState([]);

    const { getSearchedCountry, allSelectCountry, countryToggle, searchCountryTerm } = selectCountry;
    const { getSearchedCard, cardFlag, allSelectCard, recommended, fashionAndLifestyle, electronics, homeAndLiving, goldAndJewelry, travelAndEntertainment, foodAndRestaurant } = card;

    useEffect(() => {
        if (data) {
            let categories = [
                { name: "Recommended", value: "recommended", detail: data, isChecked: "" },
                { name: "Fashion & Lifestyle", value: "fashionAndLifestyle", detail: data, isChecked: "" },
                { name: "Electronics", value: "electronics", detail: data, isChecked: "" },
                { name: "Home & Living", value: "homeAndLiving", detail: data, isChecked: "" },
                { name: "Gold & Jewelry", value: "goldAndJewelry", detail: data, isChecked: "" },
                { name: "Travel & Entertainment", value: "travelAndEntertainment", detail: data, isChecked: "" },
                { name: "Food & Restaurant", value: "foodAndRestaurant", detail: data, isChecked: "" },
            ];

            setCardResponse(categories);
        }
    }, [data]);

    useEffect(() => {
        const fetchCountryRegions = async () => {
            setLoader(true);
            const token = JSON.parse(localStorage.getItem("token_gen"));
            let res = await CountryRegions(token?.access_token);
            const country = [];
            res?.map((val) => country.push({ value: val.name, label: val.displayName, isChecked: "" }));
            setState({ ...state, options: country });
            setSelectCountry({ ...selectCountry, getSearchedCountry: country });
            setLoader(false);
        };
        fetchCountryRegions();
    }, []);

    // useEffect(() => {
    //     let tempIsSelected = [];
    //     let tempAllCards = [];
    //     if (data.length > 0) {
    //         data.filter((ele, i) => {
    //             tempAllCards.push({
    //                 id: ele.id,
    //                 client_id: ele.client_id,
    //                 country_id: ele.country_id,
    //                 is_selected: ele.is_selected,
    //             });
    //             if (ele.is_selected === true) {
    //                 tempIsSelected.push(ele.id);
    //             }
    //         });
    //     }
    //     setIsSelected(tempIsSelected);
    //     setFormData({ ...formData, cardsForUpdate: tempAllCards, getCards: tempAllCards });
    // }, [data]);

    useEffect(() => {
        let tempIsSelected = [];
        if (cardResponse.length > 0) {
            cardResponse.forEach((card) => {
                card.detail.map((ele) => {
                    if (ele.is_selected === true) {
                        tempIsSelected.push(ele.id);
                    }
                });
            });
        }
        setIsSelected(tempIsSelected);
    }, [cardResponse]);

    const fetch = async (country) => {
        setLoader(true);
        const merchantCode = localStorage.getItem("merchantcode");
        let response = await giftCard(merchantCode, country);
        setData(response);
        setLoader(false);
    };

    const handleCountrySearch = (e) => {
        let temp = [];
        if (e.target.value) {
            options.filter((str) => {
                if (str.label.toLowerCase().includes(e.target.value.toLowerCase())) {
                    temp.push(str);
                }
            });
            setSelectCountry({ ...selectCountry, getSearchedCountry: temp, countryToggle: true, searchCountryTerm: e.target.value });
        } else {
            setSelectCountry({ ...selectCountry, getSearchedCountry: options, countryToggle: true, searchCountryTerm: e.target.value });
        }
    };

    const handleCardSearch = (e) => {
        let temp = [];
        if (e.target.value) {
            data.filter((str) => {
                if (str.title.toLowerCase().includes(e.target.value.toLowerCase())) {
                    temp.push(str);
                }
            });
            setCard({ ...card, getSearchedCard: temp, cardFlag: true });
        } else {
            setCard({ ...card, getSearchedCard: temp, cardFlag: false });
        }
    };
    useEffect(() => {
        fetch("IN");
    }, []);

    const handleCountryCheckbox = (e, value, label) => {
        if (value === "selectAll") {
            const allCountriesSelected = e.target.checked;
            setCountry(label);
            // fetch("US");
            let temp = [];
            if (allCountriesSelected) {
                temp = getSearchedCountry.map((country) => country.value);
                // console.log("select all country", temp);
            }

            setSelectCountry((prevState) => ({
                ...prevState,
                getSearchedCountry: prevState.getSearchedCountry.map((ele) => ({
                    ...ele,
                    isChecked: allCountriesSelected,
                })),
                allSelectCountry: allCountriesSelected ? "checked" : "",
            }));
        } else {
            setCountry(label);
            // fetch(value);
            const updatedSearchCountry = getSearchedCountry.map((ele) => (ele.value === value ? { ...ele, isChecked: e.target.checked } : ele));
            const isSelectAllChecked = updatedSearchCountry.every((ele) => ele.isChecked);
            let temp = [];
            updatedSearchCountry.length > 0 &&
                updatedSearchCountry.map((country) => {
                    if (country.isChecked === true) {
                        temp.push(country.value);
                    }
                });
            // console.log("checked country", temp);
            setSelectCountry((prevState) => ({
                ...prevState,
                getSearchedCountry: updatedSearchCountry,
                allSelectCountry: isSelectAllChecked ? "checked" : "",
            }));
        }
    };

    const handleCategory = (e, category) => {
        if (category === "selectAll") {
            const allCardsSelected = e.target.checked;

            setCard((prevState) => ({
                ...prevState,
                allSelectCard: allCardsSelected ? "checked" : "",
            }));
            setCardResponse((prevState) =>
                prevState.map((ele) => ({
                    ...ele,
                    isChecked: allCardsSelected,
                }))
            );
        } else {
            const updatedSearchCard = cardResponse.map((ele) => (ele.value === e.target.name ? { ...ele, isChecked: e.target.checked } : ele));
            const isSelectAllChecked = updatedSearchCard.every((ele) => ele.isChecked);
            setSelectCountry((prevState) => ({
                ...prevState,
                getSearchedCountry: updatedSearchCard,
                allSelectCountry: isSelectAllChecked ? "checked" : "",
            }));
            setCard((prevState) => ({
                ...prevState,
                allSelectCard: isSelectAllChecked ? "checked" : "",
            }));
            setCardResponse(updatedSearchCard);
        }
    };

    const handleSelect = (item, type, value) => {
        if (isSelected.includes(item.id)) {
            setIsSelected(isSelected.filter((id) => id !== item.id));
            setCardResponse((prevState) =>
                prevState.map((card) => {
                    if (card.value === value) {
                        return {
                            ...card,
                            detail: card.detail.map((ele) => {
                                if (ele.id === item.id) {
                                    return {
                                        ...ele,
                                        is_selected: false,
                                    };
                                }
                                return ele;
                            }),
                        };
                    }
                    return card;
                })
            );
        } else {
            setCardResponse((prevState) =>
                prevState.map((card) => {
                    if (card.value === value) {
                        return {
                            ...card,
                            detail: card.detail.map((ele) => {
                                if (ele.id === item.id) {
                                    return {
                                        ...ele,
                                        is_selected: true,
                                    };
                                }
                                return ele;
                            }),
                        };
                    }
                    return card;
                })
            );
            setIsSelected([...isSelected, item.id]);
        }
    };

    const onSubmit = async () => {
        setLoader(true);
        let body = cardsForUpdate;
        let response = await giftCardUpdate(body);
        if (response?.message?.data === "Details updated successfully") {
            // fetch(selectedCountry);
            swal({
                position: "center",
                icon: "success",
                title: response?.message?.data,
                // showConfirmButton: false,
                timer: 5000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: response?.message?.data,
                showConfirmButton: false,
                timer: 5000,
            });
        }
        setLoader(false);
    };

    return (
        <>
            <Header name={"Gift Card"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="giftcard_mainbox">
                    <div className="gc_sidebar">
                        <button className="open_country_box" onClick={() => setSelectCountry((prevState) => ({ ...prevState, countryToggle: !countryToggle, searchCountryTerm: "", getSearchedCountry: options, allSelectCountry: "" }))}>
                            <h3> Country</h3>
                                    </button>
                        <input onChange={handleCountrySearch} type="text" placeholder="Enter Country" value={searchCountryTerm} />
                        {countryToggle && (
                                                    <div className="form-group">
                                                        {getSearchedCountry?.length > 0 && (
                                                            <div className="select_all_countries">
                                                                <span>Select All</span>
                                                                <input type="checkbox" checked={allSelectCountry === "checked"} onChange={(e) => handleCountryCheckbox(e, "selectAll", "Select All")} />
                                                            </div>
                                                        )}
                                                        <div className="country-select-form-box">
                                                            {getSearchedCountry?.length > 0 ? (
                                                                getSearchedCountry.map((ele, i) => (
                                                                    <ul key={i}>
                                                                        <li>{ele.label}</li>
                                                                        <input type="checkbox" name="isChecked" checked={ele.isChecked} onChange={(e) => handleCountryCheckbox(e, ele.value, ele.label)} />
                                                                    </ul>
                                                                ))
                                                            ) : (
                                                                <p>Not found</p>
                                                            )}
                                                        </div>
                                                    </div>
                        )}
                    </div>

                    <div className="gc_contentbox">
                        <div className="gc_content_pbox">
                            <input type="text" onChange={handleCardSearch} placeholder="Search Gift Cards/Vouchers" />
                            {cardFlag ? (
                                getSearchedCard?.length > 0 ? (
                                    <Card data={getSearchedCard} handleSelect={handleSelect} isSelected={isSelected} onSubmit={onSubmit} />
                                ) : (
                                    <span>Not found</span>
                                )
                            ) : (
                                <div>
                                    <div className="select_all_giftcard">
                                        <div>Select All</div> <input type="checkbox" checked={allSelectCard === "checked"} onChange={(e) => handleCategory(e, "selectAll")} />
                                    </div>
                                    <div className="accordion" id="accordionExample">
                                        {cardResponse?.map((ele, i) => (
                                            <div className="accordion-item" key={i}>
                                                <h2 className="accordion-header" id={i}>
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#${ele.value}`} aria-expanded="false" aria-controls={ele.value}>
                                                        {ele.name}
                                                    </button>
                                                    <input type="checkbox" name={ele.value} checked={ele.isChecked} onChange={(e) => handleCategory(e, ele.value)} />
                                                </h2>
                                                <div id={ele.value} className="accordion-collapse collapse" aria-labelledby={`#${i}`} data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <Card data={ele.detail} handleSelect={handleSelect} isSelected={isSelected} value={ele.value} onSubmit={onSubmit} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GiftCardVoucher1;
